/* eslint-disable */
import { MDDEResult, MDDEQuery, IMDDEService } from "@sa/rep-mdde";
import { CubeDefinition, IOLAPMetadataApiService } from "@sa/rep-olap";
import { getJSON, post } from "../../../http";

export interface IDataServiceConfig {
  baseUrl: string;
}

export class DataService implements IMDDEService, IOLAPMetadataApiService {
  private _cache = new Map<string, any>();
  protected _baseUrl: string;

  constructor(config: IDataServiceConfig) {
    this._baseUrl = config.baseUrl;
  }

  async query(query: MDDEQuery): Promise<MDDEResult> {
    const hash = JSON.stringify(query);
    let result: Promise<MDDEResult> = this._cache.get(hash);
    if (!result) {   
      result = post(`${this._baseUrl}/data/query`, query).then(r => r.json());
      this._cache.set(hash, result);
    }
    return await result;
  }

  async getCubeDefinition(id: string): Promise<CubeDefinition> {
    let model = this._cache.get(id);
    if (!model) {
      model = getJSON<CubeDefinition>(`${this._baseUrl}/data/definition/${id}`);
      this._cache.set(id, model);
    }
    return await model;
  }
}
